<template>
  <div class="books">
    <van-list
      class="ts-list"
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="booklist.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || booklist.length > 0">
        <TsItem
          class="ts-item"
          v-for="item in booklist"
          :key="item.id"
          :title="item.goodsName"
          :cover="item.albumPics"
          :price="item.goodsPrice"
          @click.native="toBookDetails(item.id)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>

<script>
import TsItem from "@/views/mobileView/components/listItem/tsItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "books",
  components: {
    TsItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      booklist: [],
    };
  },
  methods: {
    async bookList() {
      this.loading = true;
      const resp = await this.$apis.myServe.bookList({
        pageSize: 20,
        pageNo: 1,
      });
      if (resp.resultCode == 200) {
        this.booklist = resp.data.data;
        this.finished = resp.data.data.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.bookList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toBookDetails(id) {
      this.$router.push({
        name: "bookDetails",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.books {
  // width: 100%;
  // height: 100%;
  padding: 12px;
  .ts-list {
    width: 100%;
    margin: 0 auto;
    .list-box {
      width: 100%;
      column-count: 2;
      column-gap: 1em;
      .ts-item {
        box-sizing: border-box;
        -webkit-column-break-inside: avoid;
        break-inside: avoid;
        //   max-height: 200px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>